<div class="address-modal-container">
 
    <div class="add-address-section">
        <div class="heading m-2 d-flex justify-content-between">
            <div><span class="headingClass"> {{ isEditMode ? 'Update Address' : 'Add Address' }}</span></div>
            <div><mat-icon class="cursor-pointer" (click)="closeDialog()">close</mat-icon></div>
        </div>
        <form class="address-form" #addressForm="ngForm">
            <div class="col-sm-12 row">
                <div class="col-sm-12 row m-2 form-wrap-view" style="padding: 0px !important;">
                    <div class="col-sm-4 mb-2 viewInputContainer">
                        <mat-form-field class="col-sm-12 p-0" [ngClass]="{'valuedField': newAddress.AddressLabel}">
                            <mat-label>Label</mat-label>
                            <input matInput [(ngModel)]="newAddress.AddressLabel" (ngModelChange)="onAddressChange()" name="AddressLabel" placeholder="Enter label"
                                required maxlength="50">
                        </mat-form-field>
                    </div>

                    <div class="col-sm-4 mb-2 viewInputContainer">
                        <mat-form-field class="col-sm-12 p-0" [ngClass]="{'valuedField': newAddress.Address1}">
                            <mat-label>Address 1</mat-label>
                            <input matInput [(ngModel)]="newAddress.Address1" (ngModelChange)="onAddressChange()" name="Address1"
                                placeholder="Enter address line 1" required maxlength="150">
                        </mat-form-field>
                    </div>

                    <div class="col-sm-4 mb-2 viewInputContainer">
                        <mat-form-field class="col-sm-12 p-0" [ngClass]="{'valuedField': newAddress.Address2}">
                            <mat-label>Address 2</mat-label>
                            <input matInput [(ngModel)]="newAddress.Address2" (ngModelChange)="onAddressChange()" name="Address2"
                                placeholder="Enter address line 2 (optional)" maxlength="150">
                        </mat-form-field>
                    </div>

                    <div class="col-sm-4 mb-2 viewInputContainer">
                        <mat-form-field class="col-sm-12 p-0" [ngClass]="{'valuedField': newAddress.ZipCode}">
                            <mat-label>ZIP Code</mat-label>
                            <input matInput [(ngModel)]="newAddress.ZipCode" (ngModelChange)="onAddressChange()" name="ZipCode" placeholder="Enter ZIP code"
                                required (blur)="getStateAndCity()" mask="00000-0000" maxLength="15" [dropSpecialCharacters]="false">
                        </mat-form-field>
                    </div>

                    <div class="col-sm-4 mb-2 viewAutoCompleteContainer" *ngIf="showShimmerForField">
                        <div class="shimmerField col-sm-12 p-0">

                        </div>
                    </div>
                    <div class="col-sm-4 mb-2 viewAutoCompleteContainer" *ngIf="!showShimmerForField">
                    
                        <mat-form-field class="w-100 col-sm-12 p-0 viewAutoComplete"
                            [ngClass]="{'valuedField': selectedStateNameObject['displayname']}">
                            <mat-label> State </mat-label>

                            <i class="fa fa-chevron-down chevron-align align-icon dropdownIcon"></i>

                            <input type="text" #searchInput matInput #dynamicFields trim
                                #trigger="matAutocompleteTrigger" type="text"
                                [(ngModel)]="selectedStateNameObject['displayname']" (ngModelChange)="onAddressChange()" matInput [name]="'state'"
                                [matAutocomplete]="auto1" [ngModelOptions]="{standalone: true}"
                                (input)="onAutoCompleteInputChange($event, selectedStateNameObject)" #autoComopleteText1
                                [disabled]="isStateDisabled" (blur)="checkValue()">

                            <mat-autocomplete #auto1="matAutocomplete"
                                class="customCEOverlayPanelClass listingDropdownPanel">
                                <mat-option class="mat-opt-align"
                                    *ngFor="let autoCompleteOption of filterAutomCompleteOptions(selectedStateNameObject['displayname'], 'StateDisplayName')"
                                    [value]="autoCompleteOption['AccountName']"
                                    (onSelectionChange)="onAutoCompleteSelectionChange($event, autoCompleteOption);">
                                    <div class="truncate-text" [matTooltip]="optionToolTipText"
                                        matTooltipPosition="right"
                                        (mouseenter)="enableToolTip(isOptionElipsed, 'dropdown')" #isOptionElipsed>
                                        {{ autoCompleteOption['Description'] }} ( {{ autoCompleteOption['LookupValue']
                                        }} )
                                    </div>
                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>

                    <div class="col-sm-4 mb-2 viewAutoCompleteContainer" *ngIf="showShimmerForField">
                        <div class="shimmerField col-sm-12 p-0">

                        </div>
                    </div>

                    <div class="col-sm-4 mb-2 viewInputContainer" *ngIf="!showShimmerForField">
                        <mat-form-field class="col-sm-12 p-0" [ngClass]="{'valuedField': newAddress.City}">
                            <mat-label>City</mat-label>
                            <input matInput [(ngModel)]="newAddress.City" (input)="onCityInput($event)" (ngModelChange)="onAddressChange()" name="City" placeholder="Enter city" required
                                [disabled]="isCityDisabled" maxlength="50">
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <section class="buttonSticky pb-2 pr-2">
                <div class="row pl-4 align-items-center">
                    <span class="clear-all pl-1" *ngIf="hasChanges" (click)="resetForm(addressForm)">Reset</span>
                    <button mat-stroked-button customClass="admin" class="ml-auto mr-2 secondary cursor-pointer" type="button"
                        (click)="clearForm(addressForm)">
                        Clear All
                    </button>
                    <button mat-raised-button customClass="admin" class="creation-btn-width mr-2 primary cursor-pointer" type="button"
                        [disabled]="!isFormValid()" (click)="onSubmit(addressForm)">
                        {{ isEditMode ? 'Update' : 'Add' }}
                    </button>
                </div>
            </section>
        </form>
    </div>

    <!-- Saved Addresses Section -->
    <div class="saved-addresses-section">
        <div class="section-header">
            <div class="heading ml-2 addressHeadingContainer">
                
                <div class="headingClass">Saved Addresses </div>
                <div class="col-sm-4 m-0 p-0 d-flex justify-content-center align-item-center searchContainer accountSearch">
                    <div class="global-search-panel d-flex p-0 col-md-12 mr-2">
                        <div style="display: flex; margin-right: 3px;margin-left: 4px;">
                            <mat-icon class="search-icon">search</mat-icon>
                        </div>
                        <div class="standing-line">
                        </div>
                        <input type="text" class="search-input" [placeholder]="'Search By Address, City, State or ZipCode'" [(ngModel)]="addressSearchText" [ngModelOptions]="{standalone: true}">
                        <ng-container *ngIf="addressSearchText">
                            <div class="standing-line">
                            </div>
                            <div  style="display: flex; margin-right: 3px;margin-left: 4px; cursor: pointer;"> 
                                <mat-icon class="search-icon" (click)="addressSearchText = ''">close</mat-icon>
                            </div>
                        </ng-container>
                    </div>
                    <button mat-raised-button customClass="admin" class="creation-btn-width primary cursor-pointer" type="button"
                        [disabled]="!filteredAddresses?.length" (click)="saveAddress()">
                        Save
                    </button>

                </div>
            </div>
            <!-- <div class="search-container">
                <mat-form-field appearance="outline" class="search-field">
                    <mat-label>Search</mat-label>
                    <input matInput [(ngModel)]="searchText"
                        placeholder="Search by Label, Address, ZIP Code, State, City" (input)="searchAddresses()">
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
                <button mat-raised-button color="primary" class="search-btn" (click)="searchAddresses()">
                    Search
                </button>
            </div> -->
        </div>

        
        <div class="addresses-grid row m-2" *ngIf="filteredAddresses?.length && getMessage()">
            <div *ngFor="let address of filteredAddresses; let i = index" class="address-card p-2" [ngClass]="{
                   'disabled-card': isEditMode && addressToBeEditedIndex !== i,
                   'editing-card': isEditMode && addressToBeEditedIndex === i,
                   'hidden': !isVisible(address)
                 }" (click)="editAddress(address, i, $event)">
                <div class="address-card-header d-flex">
                    <span class="address-label"
                          #labelEl
                          [matTooltip]="overflowMap['label-' + i] ? address.AddressLabel : ''"
                          (mouseenter)="checkOverflow(labelEl, 'label-' + i)">
                      {{ address.AddressLabel }}
                    </span>
                    <div class="address-actions" *ngIf="!isEditMode">
                        <mat-icon class="cursor-pointer" (click)="editAddress(address, i, $event)" matTooltip="Edit Address">edit</mat-icon>
                        <mat-icon class="cursor-pointer" (click)="deleteAddress(address.Id, i, $event)" matTooltip="Delete Address">delete</mat-icon>
                    </div>
                </div>
                <div class="address-content">
                    <p class="address-text"
                       #line1El
                       [matTooltip]="overflowMap['line1-' + i] ? (address.Address1 + (address.Address2 ? ', ' + address.Address2 : '')) : ''"
                       (mouseenter)="checkOverflow(line1El, 'line1-' + i)">
                        {{ address.Address1 }}<span *ngIf="address.Address2">, {{ address.Address2 }}</span>
                    </p>
                    <p class="address-text"
                       #line2El
                       [matTooltip]="overflowMap['line2-' + i] ? (address.City + ', ' + address.State + ' ' + address.ZipCode) : ''"
                       (mouseenter)="checkOverflow(line2El, 'line2-' + i)">
                        {{ address.City }}, {{ address.State }} {{ address.ZipCode }}
                    </p>
                </div>
            </div>
        </div>

        <!-- <div *ngIf="!filteredAddresses.length && !addressSearchText" class="no-addresses">
            <p>No Data Available.</p>
        </div> -->
        <div class="col-sm-12 nodata-header-wrap" *ngIf="!filteredAddresses.length && !addressSearchText">
            <span class="col-sm-12 nodata-wrapper"> No Data Available </span>
        </div>
        <!-- <div  *ngIf="addressSearchText && !getMessage()"  class="no-addresses">
            <p>No Results.</p>
        </div> -->
        <div class="col-sm-12 nodata-header-wrap" *ngIf="addressSearchText && !getMessage()">
            <span class="col-sm-12 nodata-wrapper"> No Results </span>
        </div>
    </div>
</div>